import { CONFIG } from '../app/config.js';

export function calculateScore(distanceUnits, collectedOrbs) {
  const distancePoints = Math.floor(Math.max(0, distanceUnits) / CONFIG.SCORING.DISTANCE_PER_POINT);
  return distancePoints + Math.max(0, collectedOrbs) * CONFIG.SCORING.ORB_VALUE;
}

export class ScoreManager {
  constructor() {
    this.distanceUnits = 0;
    this.collectedOrbs = 0;
    this.currentScore = 0;
    this.runId = null;
    this.isFrozen = false;
    this.isSubmitted = false;
    this.frozenSummary = null;
  }

  startNewRun() {
    this.distanceUnits = 0;
    this.collectedOrbs = 0;
    this.currentScore = 0;
    this.isFrozen = false;
    this.isSubmitted = false;
    this.frozenSummary = null;
    this.runId = `run_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;
    return this.runId;
  }

  updateDistance(worldSpeed, dt) {
    if (this.isFrozen) return;
    this.distanceUnits += worldSpeed * dt;
    this.currentScore = calculateScore(this.distanceUnits, this.collectedOrbs);
  }

  addOrb() {
    if (this.isFrozen) return;
    this.collectedOrbs += 1;
    this.currentScore = calculateScore(this.distanceUnits, this.collectedOrbs);
  }

  freeze() {
    if (this.isFrozen && this.frozenSummary) {
      return this.frozenSummary;
    }

    this.isFrozen = true;
    this.frozenSummary = {
      runId: this.runId,
      distance: Math.floor(this.distanceUnits),
      orbs: this.collectedOrbs,
      score: this.currentScore,
      timestamp: Date.now(),
    };

    return this.frozenSummary;
  }

  canSubmit() {
    return this.isFrozen && !this.isSubmitted;
  }

  markSubmitted() {
    this.isSubmitted = true;
  }

  getScore() {
    return this.currentScore;
  }

  getDistance() {
    return Math.floor(this.distanceUnits);
  }

  getOrbs() {
    return this.collectedOrbs;
  }

  getSummary() {
    return this.frozenSummary || {
      runId: this.runId,
      distance: Math.floor(this.distanceUnits),
      orbs: this.collectedOrbs,
      score: this.currentScore,
      timestamp: Date.now(),
    };
  }
}
